export default __webpack_public_path__ + "assets/soi_desktop.61d2f647.jpg";